import { INhomCauHoiProgressRequest } from "../../../model/request/nhom-cau-hoi/INhomCauHoiProgressRequest";
import { ISMT_NhomCauHoi } from "../../../model/respone/cau-hoi/ISMT_NhomCauHoi";
import { ISMT_NhomCauHoi_MucTriNang } from "../../../model/respone/cau-hoi/ISMT_NhomCauHoi_MucTriNang";
import { ISMT_NhomCauHoi_Vm } from "../../../model/respone/cau-hoi/ISMT_NhomCauHoi_Vm";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eNhomCauHoiActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as ISMT_NhomCauHoi_Vm[],
  LOAD_ERRR: "",

  LOAD_BY_ID_START: 0,
  LOAD_BY_ID_SUCCESS: {} as ISMT_NhomCauHoi_Vm,
  LOAD_BY_ID_ERR: "",

  // SEARCH_BY_NHOM_CAU_HOI_ID_START: 0,
  // SEARCH_BY_NHOM_CAU_HOI_ID_SUCCESS: {} as ISMT_NhomCauHoi,
  // SEARCH_BY_NHOM_CAU_HOI_ID_ERROR: "",

  SAVE_START: {} as ISMT_NhomCauHoi_Vm,
  SAVE_SUCCESS: {} as ISMT_NhomCauHoi_Vm,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  DELETE_BO_CAU_HOI_START: {} as any,
  DELETE_BO_CAU_HOI_SUCCESS: undefined,
  DELETE_BO_CAU_HOI_ERROR: "",

  SELECTED_ID: [] as number[],

  SHOW_EDIT_MODAL: {} as undefined | ISMT_NhomCauHoi_Vm,
  CLOSE_EDIT_MODAL: undefined,

  IMPORT_OPEN_MODAL: undefined,
  IMPORT_CLOSE_MODAL: undefined,
  IMPORT_START: {} as FormData,
  IMPORT_SUCCESS: "",
  IMPORT_ERROR: "",

  SHOW_ADD_MUCTRINANG_MODAL: {} as ISMT_NhomCauHoi_Vm,
  CLOSE_ADD_MUCTRINANG_MODAL: undefined,
  SAVE_MUCTRINANG_START: {} as ISMT_NhomCauHoi_MucTriNang[],
  SAVE_MUCTRINANG_SUCCESS: undefined,
  SAVE_MUCTRINANG_ERROR: "",

  SHOW_PROGRESS_MODAL: {} as number[],
  CLOSE_PROGRESS_MODAL: undefined,

  PROGRESS_START: {} as INhomCauHoiProgressRequest,
  PROGRESS_SUCCESS: undefined,
  PROGRESS_ERROR: "",

  CHANGE_REQUEST: {} as any,

  SYNC_VNPT_START: undefined,
  SYNC_VNPT_SUCCESS: undefined,
  SYNC_VNPT_ERROR: "",
};
export const eNhomCauHoiActionIds = generateActionTypeIds(
  eNhomCauHoiActionsObj,
  "NHOM_CAU_HOI"
);
export type INhomCauHoiActionTypes = IGenericActionType<
  typeof eNhomCauHoiActionsObj,
  "NHOM_CAU_HOI"
>;
